import { IBanksReset } from "./types";

const checkIfResetsDatesEqual = (banksReset: IBanksReset[]) =>
  banksReset.length > 0 &&
  banksReset.every((bank) => bank.resetTime === banksReset[0].resetTime);

export default checkIfResetsDatesEqual;
